import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import { Badge } from "antd";
import StandardTableLayout from "../../layouts/StandardTableLayout/StandardTableLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  FETCH_ALL_EMPLOYMENT_TYPE_IN_ORGANISATION,
  setEmploymentTypes,
  DELETING_EMPLOYMENT_TYPE,
} from "../../store/team-member-store/reducer";
import StandardListLayout from "../../layouts/StandardTableLayout/StandardListLayout";

const EmploymentTypes = () => {
  const dispatch = useDispatch();
  const { organisationId } = useSelector(({ auth }) => auth.user);
  const { employmentTypes } = useSelector(({ team }) => team.teamReducer);
  const [isLoading, setIsLoading] = useState(true);
  const { csvExportData } = useSelector(({ user }) => user.userReducer);
  const [csv, setCsv] = useState({
    headers: [
      {
        label: "Description",
        key: "description",
      },
      {
        label: "Status",
        key: "status",
      },
    ],
    data: [],
    fileName: "allEmploymentTypes.csv",
  });
  const [dataList, setDataList] = useState([]);

  const handleColumnCsv = (array) => {
    let csvData = [];
    array.forEach((e) => {
      csvData.push({
        description: e.description,
        status: e.status,
      });
    });
    return csvData;
  };

  const columns = [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let type = status === true ? "success" : "error";
        return <Badge status={type} text={status ? "Active" : "InActive"} />;
      },
      sorter: (a, b) => b.status - a.status,
    },
  ];

  const FETCH_DATA = () => {
    FETCH_ALL_EMPLOYMENT_TYPE_IN_ORGANISATION(organisationId)
      .then((data) => dispatch(setEmploymentTypes(data)))
      .finally(() => setIsLoading(false));
  };
  useEffect(() => {
    FETCH_DATA();
  }, [organisationId]);

  useEffect(() => {
    if (employmentTypes) {
      const columns = handleColumnCsv(employmentTypes);
      setCsv({
        ...csv,
        data: columns,
      });
    }
  }, [employmentTypes]);

  useEffect(() => {
    if (csvExportData.length > 0) {
      const columns = handleColumnCsv(csvExportData);
      setCsv({
        ...csv,
        data: columns,
      });
    }
  }, [csvExportData]);

  useEffect(() => {
    const newDoc = [];
    employmentTypes?.forEach((ele, index) => {
      let data = {
        _id: ele?._id,
        title: `${ele?.description}`,
        description: `${ele?.status ? "Active" : "Inactive"}`,
      };
      newDoc.push(data);
    });
    setDataList(newDoc);
  }, [employmentTypes]);

  return (
    <div className="team_member">
      <div className="table-layouts">
        <div className="tables">
          <StandardTableLayout
            csvHeader={csv.headers || null}
            csvData={csv.data || null}
            csvFileName={csv.fileName || null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Employment Types" }]}
            dataSource={employmentTypes}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETING_EMPLOYMENT_TYPE}
            table="employment/types"
          />
        </div>
        <div className="table-lists">
          <StandardListLayout
            csvHeader={csv.headers || null}
            csvData={csv.data || null}
            csvFileName={csv.fileName || null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Employment Types" }]}
            dataList={dataList}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETING_EMPLOYMENT_TYPE}
            table="employment/types"
          />
        </div>
      </div>
    </div>
  );
};

export default EmploymentTypes;
